import { IModule } from 'redux-dynamic-modules';

import { MandantConfigState } from './MandantConfigState';
import { loadMandantData } from './api/loadMandantData';
import { MandantConfigReducer } from './reducer';

export const getMandantConfigModule = (): IModule<{ MandantConfig: MandantConfigState }> => ({
  id: 'MandantConfig',
  reducerMap: {
    MandantConfig: MandantConfigReducer,
  },
  // TODO: Check if this works
  // @ts-expect-error This should not work according to the types, but it did in app-interhyp-home
  initialActions: [loadMandantData()],
  finalActions: [],
});
